import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        resetPassword: builder.mutation({
            query: (body) => ({
                url: `admin/resetPassword`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
        getUserEmail: builder.mutation({
            query: (body) => ({
                url: `admin/getEmail`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
    })
})

export const { useResetPasswordMutation, useGetUserEmailMutation } = Api